import { render, staticRenderFns } from "./ThemesEditorSectionMenu.vue?vue&type=template&id=6e532306"
import script from "./ThemesEditorSectionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorSectionMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports